export default __webpack_public_path__ + "static/1-d930e06be0d4b11bc36eb0eefdeac8c0.jpg";